export const CALIFORNIA = 'California';
export const COLORADO = 'Colorado';
export const CONNECTICUT = 'Connecticut';
export const DELAWARE = 'Delaware';
export const INDIANA = 'Indiana';
export const IOWA = 'Iowa';
export const KENTUCKY = 'Kentucky';
export const MARYLAND = 'Maryland';
export const MINNESOTA = 'Minnesota';
export const MONTANA = 'Montana';
export const NEBRASKA = 'Nebraska';
export const NEW_HAMPSHIRE = 'New Hampshire';
export const NEW_JERSEY = 'New Jersey';
export const OREGON = 'Oregon';
export const RHODE_ISLAND = 'Rhode Island';
export const TENNESSEE = 'Tennessee';
export const TEXAS = 'Texas';
export const UTAH = 'Utah';
export const VIRGINIA = 'Virginia';

export const PrivacyPolicyStateLaws = {
  [CALIFORNIA]: {
    href: 'https://leginfo.legislature.ca.gov/faces/codes_displayText.xhtml?division=3.&part=4.&lawCode=CIV&title=1.81.5',
  },
  [COLORADO]: {
    href: 'https://coag.gov/resources/colorado-privacy-act/',
  },
  [CONNECTICUT]: {
    href: 'https://www.cga.ct.gov/2024/sup/chap_743jj.htm',
  },
  [DELAWARE]: {
    href: 'https://delcode.delaware.gov/title6/c012d/index.html',
  },
  [INDIANA]: {
    href: 'https://iga.in.gov/laws/2024/ic/titles/24#24-15-1',
  },
  [IOWA]: {
    href: 'https://www.legis.iowa.gov/docs/publications/iactc/90.1/CH17.pdf',
  },
  [KENTUCKY]: {
    href: 'https://apps.legislature.ky.gov/law/statutes/chapter.aspx?id=39092',
  },
  [MARYLAND]: {
    href: 'https://mgaleg.maryland.gov/2024RS/chapters_noln/Ch_455_sb0541E.pdf',
  },
  [MINNESOTA]: {
    href: 'https://www.revisor.mn.gov/laws/2024/0/Session+Law/Chapter/121/#:~:text=CONSUMER%20DATA%20POLICY',
  },
  [MONTANA]: {
    href: 'https://archive.legmt.gov/bills/mca/title_0300/chapter_0140/part_0280/sections_index.html',
  },
  [NEBRASKA]: {
    href: 'https://nebraskalegislature.gov/laws/statutes.php?statute=87-1101',
  },
  [NEW_HAMPSHIRE]: {
    href: 'https://gc.nh.gov/rsa/html/NHTOC/NHTOC-LII-507-H.htm',
  },
  [NEW_JERSEY]: {
    href: 'https://pub.njleg.state.nj.us/Bills/2022/PL23/266_.HTM',
  },
  [OREGON]: {
    href: 'https://www.oregonlegislature.gov/bills_laws/ors/ors646A.html',
  },
  [RHODE_ISLAND]: {
    href: 'https://webserver.rilegislature.gov/Statutes/TITLE6/6-48.1/INDEX.htm',
  },
  [TENNESSEE]: {
    href: 'https://publications.tnsosfiles.com/acts/113/pub/pc0408.pdf',
  },
  [TEXAS]: {
    href: 'https://statutes.capitol.texas.gov/Docs/BC/htm/BC.541.htm',
  },
  [UTAH]: {
    href: 'https://le.utah.gov/xcode/Title13/Chapter61/13-61.html?v=C13-61_2022050420231231',
  },
  [VIRGINIA]: {
    href: 'https://law.lis.virginia.gov/vacodefull/title59.1/chapter53/',
  },
};
